import { render, staticRenderFns } from "./elCode.vue?vue&type=template&id=52d77bc8&scoped=true"
import script from "./elCode.vue?vue&type=script&lang=js"
export * from "./elCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d77bc8",
  null
  
)

export default component.exports